export function NullayerLogo({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* 外层圆环 - 代表 "层" */}
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="url(#gradient1)"
        strokeWidth="2"
        fill="none"
        opacity="0.6"
      />

      {/* 中间圆环 */}
      <circle
        cx="24"
        cy="24"
        r="14"
        stroke="url(#gradient1)"
        strokeWidth="1.5"
        fill="none"
        opacity="0.4"
      />

      {/* 内部 "0" - 代表 "Null" */}
      <circle
        cx="24"
        cy="24"
        r="8"
        stroke="url(#gradient1)"
        strokeWidth="3"
        fill="none"
      />

      {/* 锁的符号 */}
      <path
        d="M24 20 L24 28"
        stroke="url(#gradient2)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="24"
        cy="24"
        r="2"
        fill="url(#gradient2)"
      />

      {/* 渐变定义 */}
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#8b5cf6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#a855f7', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#a855f7', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#fff', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function NullayerLogoSimple({ size = 24, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* 简化版 - 只有核心元素 */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="url(#simpleGradient)"
        strokeWidth="2"
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r="5"
        stroke="url(#simpleGradient)"
        strokeWidth="2"
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r="1.5"
        fill="url(#simpleGradient)"
      />

      <defs>
        <linearGradient id="simpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#8b5cf6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#a855f7', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
    </svg>
  )
}
